
type CommitParams = {name: string, description: string};

/**
 * The InputChangeEvent class extends CustomEvent to signify that this type of
 * change event can provide an custom undo message. The undo message is easy to
 * construct for primitive values (numbers, strings, etc.), but for objects
 * that are changed by an Input widget, e.g. Frame, Panel, or Material
 * instances, the Input widget itself needs to specify the undo message.
 *
 * The intended usage inside an input component would look like this:
 *
 *     this.dispatchEvent(
 *         new InputChangeEvent(`set material pattern to ${label}`));
 *
 * Note that InputChangeEvents will bubble out of the web component so that
 * all change events can be handled uniformly at the Properties level and input
 * components can be nested.
 */
export default class InputChangeEvent extends CustomEvent<CommitParams> {

    constructor(name: string, description: string)
    {
        super('change', {
            detail: { name, description},
            bubbles: true,
            composed: true,
        });
    }

    getChangeName(): string {
        return this.detail.name;
    }

    /**
     * This is called by the automatically generated Properties class when the
     * event is an instance of InputChangeEvent.
     */
    getChangeDescription(): string {
        return this.detail.description;
    }
}
